import {useMutation, useQueryClient} from '@tanstack/react-query';

import ResponsesRepository from '../../../networking/repos/ResponsesRepository';
import Response from '../../../networking/models/Response';
import {ResponseQueryKey} from './Key';

export const useResponseSaveMutation = (universityId: number) => {
    const queryClient = useQueryClient();
    const repo = new ResponsesRepository(universityId);

    return useMutation({
        mutationFn: (response: Response) => repo.save(response),
        onSuccess: () => queryClient.invalidateQueries(ResponseQueryKey.index({ universityId }))
    });
};
